import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IPrismSettingsDTO, getPrismSettings } from 'wisestep-api';
import { object, string } from 'yup';

import { SettingsHeader } from '../../components/SettingsHeader';
import SettingsIndex from '../../components/SettingsIndex';
import { WsBreadCrumbs } from '../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../teams/helper/defaultValues';

import UserSession from './UserSession';
const SessionManagement = () => {
  const [prismSettingsData, setPrismSettingsData] = useState<IPrismSettingsDTO>();
  const formDefaultValues = {
    proxy: prismSettingsData?.proxy ?? '',
    userName: prismSettingsData?.userName ?? '',
    password: prismSettingsData?.password ?? '',
    enabled: prismSettingsData?.enabled ?? false,
  };
  const validationSchema = object().shape({
    proxy: string().required('IP Address with is required'),
    userName: string().required('Username is required'),
    password: string().required('Password is required'),
  });
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: formDefaultValues,
  };
  const methods = useForm(formOptions);
  const { reset } = methods;
  useEffect(() => {
    (async function () {
      const getPrismSettingsData = await getPrismSettings();
      if (getPrismSettingsData.data) {
        const temp = getPrismSettingsData.data;
        setPrismSettingsData(getPrismSettingsData.data);
        reset(temp);
      }
    })();
  }, [reset]);
  return (
    <Box>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
          Pages['PRISM_SETTINGS']
        )}
      />
      <SettingsHeader title="Prism Settings" />
      <Grid container spacing={2}>
        <Grid item xs={3} mt={2} borderRadius={1.5}>
          <SettingsIndex
            options={[
              {
                label: 'Prism Extension Settings',
                url: '/prism-extension-settings/',
              },
              {
                label: 'User Management',
                url: '/prism-user-management/',
              },
              {
                label: 'Session Management',
                url: '/prism-session-management/',
              },
            ]}
          />
        </Grid>
        <Grid item xs={9} mt={2} borderRadius={1.5} container direction="column">
          <UserSession />
        </Grid>
      </Grid>
    </Box>
  );
};
export default SessionManagement;
